/*
  Fast köprad på produktsidans mobilvy.

  Raden har ingen egen köplogik. Knappen klickar på produktformulärets
  riktiga köpknapp, så varianter, antal, felmeddelanden och varukorgslådan
  beter sig precis som när kunden trycker på knappen i sidan.

  Priset speglas från sidans prisvisning varje gång raden visas, så det
  följer med när kunden byter variant.
*/
if (!customElements.get('tp-sticky-buy')) {
  customElements.define(
    'tp-sticky-buy',
    class TpStickyBuy extends HTMLElement {
      connectedCallback() {
        this.knapp = this.querySelector('[data-tp-buybar-btn]');
        this.prisEl = this.querySelector('[data-tp-buybar-price]');
        if (!this.knapp) return;

        // Köpknappen kan renderas efter att elementet kopplats in. Försök
        // några gånger innan raden ger upp, i stället för att tyst förbli
        // osynlig resten av besöket.
        this.koppla(0);
      }

      koppla(forsok) {
        this.riktigKnapp = this.hittaRiktigKnapp();
        if (!this.riktigKnapp) {
          if (forsok < 10) setTimeout(() => this.koppla(forsok + 1), 300);
          return;
        }

        this.knapp.addEventListener('click', () => {
          this.speglaPris();
          this.riktigKnapp.click();
        });

        // Visa raden när köpknappen rullat ur bild uppåt, inte innan
        // kunden nått dit.
        //
        // Här används en scroll-lyssnare och inte IntersectionObserver.
        // En observer rapporterar bara när tillståndet ändras, och ett
        // hopp från "under vyn" till "ovanför vyn" är ingen ändring —
        // båda är "syns inte". Då uteblir beskedet helt, vilket händer
        // vid ankarlänkar och när webbläsaren återställer scrollpositionen.
        this.kolla = () => {
          if (this.vantar) return;
          this.vantar = true;
          requestAnimationFrame(() => {
            this.vantar = false;
            const r = this.riktigKnapp.getBoundingClientRect();
            this.visa(r.bottom < 0);
          });
        };
        window.addEventListener('scroll', this.kolla, { passive: true });
        window.addEventListener('resize', this.kolla, { passive: true });
        this.kolla();
      }

      disconnectedCallback() {
        if (this.kolla) {
          window.removeEventListener('scroll', this.kolla);
          window.removeEventListener('resize', this.kolla);
        }
      }

      hittaRiktigKnapp() {
        // Produktsidan har flera /cart/add-formulär och bara ett av dem
        // innehåller köpknappen — det första är tomt. Leta därför igenom
        // alla, i stället för att ta det första som dyker upp.
        const former = document.querySelectorAll('form[action*="/cart/add"]');
        for (const form of former) {
          const knapp =
            form.querySelector('.main-product_atc-btn') ||
            form.querySelector('.form-wrapper_button') ||
            form.querySelector('button[type="submit"]');
          if (knapp) return knapp;
        }
        return null;
      }

      speglaPris() {
        if (!this.prisEl) return;
        const kalla =
          document.querySelector('[data-render-price] .price_regular') ||
          document.querySelector('[data-render-price]') ||
          document.querySelector('.main-product_price-col');
        if (!kalla) return;
        // Prisvisningen innehåller dolda etiketter för skärmläsare
        // ("Ordinarie pris", "Reapris"). De ska inte med i köpraden.
        const kopia = kalla.cloneNode(true);
        kopia.querySelectorAll('.visually-hidden, .visually-hidden-focusable').forEach((n) => n.remove());
        const text = kopia.textContent.replace(/\s+/g, ' ').trim();
        if (text) this.prisEl.textContent = text;
      }

      visa(pa) {
        if (pa === this.synlig) return;
        this.synlig = pa;
        this.classList.toggle('is-visible', pa);
        if (pa) this.speglaPris();
      }
    }
  );
}
